import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { DialogContent } from '../../../../components/Authentication/components/DialogLayout/DialogContent.js';
import { NextImage } from '../../../../components/internal/NextImage/index.js';
import { useAuthentication } from '../../../../hooks/index.js';
import { ContentLayerBody, HeadlineLarge, ParagraphMedium, Stack } from '../../../../primitives/index.js';
import { qaId } from '../../../../utils/index.js';
import { AUTHENTICATION_QA_ID } from '../../../../utils/qaId.js';
export const DialogLayout = ({
  icon,
  onClose,
  title,
  subtitle,
  controllers,
  dialog
}) => {
  const {
    isComponentOpen
  } = useAuthentication();
  const {
    t
  } = useTranslation('authentication');
  return _jsx(DialogContent, {
    open: isComponentOpen('dialog', dialog),
    onClose: onClose,
    small: true,
    "data-testid": qaId(AUTHENTICATION_QA_ID, `${dialog}-dialog`),
    closeButtonLabel: t('closeDialog'),
    children: _jsxs(ContentLayerBody, {
      children: [_jsx(NextImage, {
        image: icon,
        width: 200,
        height: 200,
        alt: ""
      }), _jsxs(Stack, {
        spacing: "medium",
        alignItems: "normal",
        children: [_jsx(HeadlineLarge, {
          children: title
        }), subtitle && _jsx(ParagraphMedium, {
          color: "contentSecondary",
          children: subtitle
        })]
      }), controllers]
    })
  });
};